export default {"src":"/_next/static/media/shareIcon.34164311.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};